var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.985 26.9355C12.179 26.475 8.12903 23.4945 4.83203 18C8.43203 12 12.932 9 18.332 9C23.732 9 28.232 12 31.832 18C31.5168 18.5263 31.1852 19.0426 30.8375 19.548M22.832 28.5L25.832 31.5L31.832 25.5M15.332 18C15.332 18.7956 15.6481 19.5587 16.2107 20.1213C16.7733 20.6839 17.5364 21 18.332 21C19.1277 21 19.8907 20.6839 20.4534 20.1213C21.016 19.5587 21.332 18.7956 21.332 18C21.332 17.2044 21.016 16.4413 20.4534 15.8787C19.8907 15.3161 19.1277 15 18.332 15C17.5364 15 16.7733 15.3161 16.2107 15.8787C15.6481 16.4413 15.332 17.2044 15.332 18Z",
    stroke: "#DE1F4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCheck);
export default __webpack_public_path__ + "static/media/eye-check.02845cebd744e4fb3bcbba1d9c2d964e.svg";
export { ForwardRef as ReactComponent };